﻿// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler.js';

// App imports.
import newsApp from './vue/news.js';
import productsApp from './vue/products.js';
import amazonApp from './vue/amazon.js';
import quizApp from './vue/quiz.js';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const newsOverviewContainer = document.getElementById('news-overview');
    const productOverviewContainer = document.getElementById('product-overview');

    const newsWidgetContainers = document.querySelectorAll('.widget-news');
    const productWidgetContainers = document.querySelectorAll('.widget-product');
    const quizWidgetContainers = document.querySelectorAll('.widget-quiz');
    const amazonContainers = document.querySelectorAll('.amazon-container');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (newsOverviewContainer) {
        createApp(newsApp).mount(newsOverviewContainer);
    }

    if (productOverviewContainer) {
        createApp(productsApp).mount(productOverviewContainer);
    }

    if (newsWidgetContainers.length) {
        newsWidgetContainers.forEach((container) => {
            createApp(newsApp).mount(container);
        });
    }

    if (productWidgetContainers.length) {
        productWidgetContainers.forEach((container) => {
            createApp(productsApp).mount(container);
        });
    }

    if (quizWidgetContainers.length) {
        quizWidgetContainers.forEach((container) => {
            createApp(quizApp).mount(container);
        });
    }

    if (amazonContainers.length) {
        amazonContainers.forEach((container) => {
            createApp(amazonApp).mount(container);
        });
    }
});
